import { memo } from 'react';
import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { Modal } from '@mui/material';
import { DocumentSignDialogProps } from './document-sign-dialog.types';
import {
  DialogLayout,
  DocumentSignDialogContent,
} from './document-sign-dialog-content/document-sign-dialog-content';
import { useGetDocumentDetails } from '../../table/hooks/use-get-document-details';

export const DocumentSignDialog = memo(
  ({ isOpen, onClose, documentId }: DocumentSignDialogProps) => {
    const documentDetailQuery = useGetDocumentDetails(documentId);

    if (documentDetailQuery.status !== 'success') {
      return (
        <Modal open={isOpen} onClose={onClose}>
          <DialogLayout>
            <RenderUnsettledUI
              renderLoading={() => <SmallLoader />}
              renderError={(error) => <SmallError error={error} />}
              data={documentDetailQuery}
            />
          </DialogLayout>
        </Modal>
      );
    }

    return (
      <DocumentSignDialogContent
        documentId={documentId}
        isOpen={isOpen}
        onClose={onClose}
        documentData={documentDetailQuery.data}
      />
    );
  }
);
